import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import t from 'ember-intl/helpers/t';
import type { WrFormComponentSignature } from 'ember-wiser/components/form';

interface Signature {
  Args: {
    onClick: () => void;
    form: WrFormComponentSignature<
      EmberChangeset,
      void
    >['Blocks']['default'][0];
  };
}

export default <template>
  <@form.RadioRow
    @name='hasFistulas'
    @label={{t 'mici-form.hasFistulas.long' htmlSafe=true}}
    @onClick={{@onClick}}
    as |Radio|
  >
    <Radio @value='true' @label='Oui' />
    <Radio @value='false' @label='Non' />
  </@form.RadioRow>
</template> satisfies TOC<Signature>;
